// extracted by mini-css-extract-plugin
export default {"buttonsHolder":"FileManagementCustom_buttonsHolder__BFvei"};